module.exports = __webpack_public_path__ + "img/offlineOnline.89a052a1.png";